import {useBasketStore} from "@/Stores/Site/Basket";

type Params = {
    productId?: number | null;
    productDataId?: number | null;
};

export const useBasket = () => {
    const basketProducts = useBasketStore(s => s.basketProducts);

    const inBasket = ({productId, productDataId}: Params) => {
        if (productId == null && productDataId == null) {
            return false;
        }

        return basketProducts.some(product => {
            if (productDataId != null) {
                return product.product_data_id === productDataId;
            }

            return product.product_id === productId;
        });
    };

    return {inBasket};
};
